/* eslint-disable no-unused-vars */
import { config } from '@js/state';

let sound = true;
let settings = false;
let interacted = false;
let call = 0;
let slideDown;
let animsList = [];
let value = 0;
let round = 0;
let rect;
let circX = 530;
let bar = [];

export default class UiScene extends Phaser.Scene {
  constructor() {
    super({ key: 'UiScene' });
  }

  preload() {}

  create() {
    this.bar = this.add.image(0, 0, 'mask').setOrigin(0);
    this.shape = this.make.graphics();
    this.shape.beginPath();
    this.shape.fillRect(0, 75, 1280, 150);
    this.mask = this.shape.createGeometryMask();

    this.dropDown = this.add.image(1220, 145, 'dropDown').setOrigin(0.5, 0.5);
    this.sound = this.add
      .image(1220, 132, 'sound')
      .setOrigin(0.5, 0.5)
      .setDepth(2)
      .setScale(0.75)
      .setInteractive({ cursor: 'pointer' });
    this.fullScreenOff = this.add
      .image(1220, 185, 'fullScreenOff')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setScale(0.73)
      .setInteractive({ cursor: 'pointer' });

    this.progressBar = this.add.image(516, 8, 'progressBar').setOrigin(0);

    this.animCreate('teraIn', 'teraIn', 0, 30, 'teraIn', 30, 0, false);
    animsList.push('teraIn');
    this.animCreate('teraIdle', 'teraIdle', 0, 40, 'teraIdleBlink', 24, -1, false);
    animsList.push('teraIdle');
    this.animCreate('teraCorrect', 'teraCorrect', 0, 111, 'teraCorrect', 30, 0, false);
    animsList.push('teraCorrect');
    this.animCreate('teraWrong', 'teraWrong', 0, 114, 'teraWrong', 30, 0, false);
    animsList.push('teraWrong');
    this.animCreate('teraThinkStart', 'teraThink', 0, 30, 'teraThink', 30, 0, false);
    animsList.push('teraThinkStart');
    this.animCreate('teraThinkLoop', 'teraThink', 31, 90, 'teraThink', 30, -1, true);
    animsList.push('teraThinkLoop');
    this.animCreate('teraThinkOut', 'teraThink', 91, 111, 'teraThink', 30, 0, false);
    animsList.push('teraThinkOut');
    this.animCreate('teraIdea', 'teraIdea', 0, 82, 'teraIdea', 30, 0, false);
    animsList.push('teraIdea');
    this.animCreate('teraOut', 'teraOut', 0, 25, 'teraOut', 30, 0, false);
    animsList.push('teraOut');

    this.holder = this.add.image(70, 42, 'holder').setOrigin(0);
    this.holder.displayWidth = 0;
    this.q = this.add
      .image(168, 76 + 16, 'q')
      .setOrigin(0, 0.5)
      .setAlpha(0);
    this.tera = this.add.sprite(75, 93, 'teraIn').play('teraIn');

    this.hint = this.add
      .image(100, 650, 'hint')
      .setScale(0.8)
      .setVisible(false)
      .setInteractive({ cursor: 'pointer' });
    this.buttonScale(this.hint, 0.7, 350, 100, -1);

    rect = this.add.rectangle(535, 18, 1, 5, 0xffcf56, 1).setOrigin(0);

    this.paused = this.add
      .image(0, 0, 'paused')
      .setDepth(2)
      .setOrigin(0)
      .setVisible(false)
      .setInteractive();

    this.container = this.add
      .container(0, -130, [this.dropDown, this.sound, this.fullScreenOff])
      .setDepth(2);
    this.container.setMask(this.mask);

    this.yellow = this.add.image(1220, 72, 'yellow').setDepth(2).setOrigin(0.5, 0.5);
    this.circle = this.add
      .image(1220, 72, 'circle')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setInteractive({ cursor: 'pointer' });

    this.animCreate('pause', 'playAnim', 21, 21, 'playPause', 30, 0, false);
    this.animCreate('pausePlay', 'playAnim', 21, 39, 'playPause', 30, 0, false);

    this.pause = this.add
      .sprite(1125, 72, 'playAnim')
      .setDepth(2)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .play('pause');
    this.pause.on(
      'pointerup',
      function (pointer) {
        if (this.paused.visible == false) {
          this.pause.anims.play('pausePlay');
          for (let i = 0; i < animsList.length; i++)
            this.anims.get(animsList[i]).pause();
          this.game.sound.pauseAll();
          this.paused.setVisible(true);
          this.pauseAllScenes();
        } else {
          for (let i = 0; i < animsList.length; i++)
            this.anims.get(animsList[i]).resume();
          this.game.sound.resumeAll();
          this.pause.anims.playReverse('pausePlay', true);
          this.paused.setVisible(false);
          this.resumeAllScenes();
        }
      },
      this,
    );

    this.circle.on(
      'pointerup',
      function (pointer) {
        settings = true;
        if (settings == true && this.container.y == -130) {
          settings = false;
          this.buttonScale(this.yellow, 0.9, 200, 50, 0);
          this.whiteCircleTween(60);
          this.time.delayedCall(
            200,
            () => {
              this.menuSlideDown(0);
            },
            [],
            this,
          );
        }
        if (settings == true && this.container.y == 0) {
          settings = false;
          this.buttonScale(this.yellow, 0.97, 75, 10, 0);
          this.buttonScale(this.dropDown, 0.97, 75, 10, 0);
          this.whiteCircleTween(-60);
          this.time.delayedCall(
            200,
            () => {
              this.menuSlideDown(-130);
            },
            [],
            this,
          );
        }
      },
      this,
    );

    this.sound.on(
      'pointerup',
      function (pointer) {
        sound = true;
        interacted = true;
        this.buttonScale(this.sound, 0.85, 75, 10, 0);
        if (this.game.sound.mute == false && sound == true) {
          this.game.sound.setMute(true);
          this.sound.setTexture('mute');
          sound = false;
        }
        if (this.game.sound.mute == true && sound == true) {
          this.game.sound.setMute(false);
          this.sound.setTexture('sound');
          sound = false;
        }
      },
      this,
    );

    this.fullScreenOff.on(
      'pointerup',
      function (pointer) {
        interacted = true;
        this.buttonScale(this.fullScreenOff, 0.83, 75, 10, 0);
        if (this.scale.isFullscreen) {
          this.scale.stopFullscreen();
          this.fullScreenOff.setTexture('fullScreen');
        } else {
          this.scale.startFullscreen();
          this.fullScreenOff.setTexture('fullScreenOff');
        }
      },
      this,
    );
  }

  settingsAutoCollapse() {
    this.time.delayedCall(
      5000,
      () => {
        if (interacted == false) {
          this.menuSlideDown(-130);
        }
        if (interacted == true) call = 0;
      },
      [],
      this,
    );
  }

  pauseAllScenes() {
    this.scene.manager.scenes.forEach(function (scene) {
      if (scene.scene.isActive() && scene.scene.key != 'UiScene') {
        scene.scene.pause();
      }
    });
  }

  resumeAllScenes() {
    this.scene.manager.scenes.forEach(function (scene) {
      if (scene.scene.isPaused() && scene.scene.key != 'UiScene') {
        scene.scene.resume();
      }
    });
  }

  teraThink() {}

  buttonScale(object, scale, duration, delay, repeat) {
    this.tweens.add(
      {
        targets: object,
        scale: scale,
        ease: 'Sine.easeInOut',
        duration: duration,
        delay: delay,
        repeat: repeat,
        yoyo: true,
      },
      this,
    );
  }

  menuSlideDown(y) {
    slideDown = this.tweens.add(
      {
        targets: this.container,
        y: y,
        ease: 'Linear',
        duration: 500,
        delay: 100,
        repeat: 0,
        oncomplete: () => {
          if (y == 0) call = 0;
        },
      },
      this,
    );
  }

  whiteCircleTween(angle) {
    this.tweens.add(
      {
        targets: [this.circle],
        x: 1219,
        y: 70,
        ease: 'Sine.easeInOut',
        duration: 75,
        delay: 10,
        repeat: 0,
        yoyo: true,
        oncomplete: () => {
          this.tweens.add(
            {
              targets: [this.circle],
              angle: angle,
              ease: 'Power1',
              duration: 500,
              delay: 25,
              repeat: 0,
            },
            this,
          );
        },
      },
      this,
    );
  }

  animCreate(key, frames, start, end, prefix, frameRate, repeat, yoyo) {
    this.anims.create({
      key: key,
      frames: this.anims.generateFrameNames(frames, {
        start: start,
        end: end,
        prefix: prefix,
        suffix: '.png',
      }),
      frameRate: frameRate,
      repeat: repeat,
      yoyo: yoyo,
    });
  }

  textHolderTween(width, duration, delay) {
    this.tweens.add(
      {
        targets: this.holder,
        displayWidth: width,
        ease: 'Sine.easeInOut',
        duration: duration,
        delay: delay,
        repeat: 0,
        oncomplete: () => {
          this.time.delayedCall(
            200,
            () => {
              if (width == 1002) this.objectFadeInOut(1, 1000, 250);
            },
            [],
            this,
          );
        },
      },
      this,
    );
  }

  objectFadeInOut(alpha, duration, delay) {
    this.tweens.add(
      {
        targets: this.q,
        alpha: alpha,
        ease: 'Cubic',
        duration: duration,
        delay: delay,
        repeat: 0,
        oncomplete: () => {
          if (alpha == 1) {
            this.tera.setTexture('teraIdle');
            this.tera.anims.play('teraIdle');
          }
          this.time.delayedCall(
            200,
            () => {
              if (alpha == 0) this.textHolderTween(0, 500, 50);
            },
            [],
            this,
          );
        },
      },
      this,
    );
  }

  yellowCircleDraw() {
    this.circle1 = new Phaser.Geom.Circle(circX, 21, 6);
    bar.push(this.circle1);
    this.yellow1 = this.add.graphics({
      fillStyle: { color: 0xffdc83, alpha: 1 },
    });
    this.yellow1.fillCircleShape(this.circle1);
  }

  update() {
    if (round == 2) {
      if (value < 37) value += 1;
      if (value == 37) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 3) {
      if (value < 80) value += 1;
      if (value == 80) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 4) {
      if (value < 123) value += 1;
      if (value == 123) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 5) {
      if (value < 166) value += 1;
      if (value == 166) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 6) {
      if (value < 209) value += 1;
      if (value == 209) {
        this.yellowCircleDraw();
        value++;
        round++;
      }
    }

    rect.setDisplaySize(1 * value, 5);
    if (round == 7) {
      this.time.delayedCall(
        500,
        () => {
          rect.setFillStyle(0x3dd771, 1);
          this.green = this.add.graphics({
            fillStyle: { color: 0x3dd771, alpha: 1 },
          });
          for (let i = 0; i < bar.length; i++) {
            this.green.fillCircleShape(bar[i]);
            if (i == 5) {
              round = 8;
            }
          }
        },
        [],
        this,
      );
    }

    if (this.container.y == 0 && call == 0) {
      call++;
      this.settingsAutoCollapse();
      interacted = false;
    }
  }

  updateProgressUi() {
    if (round < 6) {
      if (round == 0) this.yellowCircleDraw();
      round++;
      if (round == 2) circX += 47;
      if (round >= 3) circX += 43;
    }
  }

  runCorrectUi() {
    this.updateProgressUi();
    if (
      (this.tera.anims.isPlaying && this.tera.anims.currentAnim.key == 'teraThink') ||
      (this.tera.anims.isPlaying &&
        this.tera.anims.currentAnim.key == 'teraThinkStart') ||
      (this.tera.anims.isPlaying &&
        this.tera.anims.currentAnim.key == 'teraThinkLoop')
    ) {
      this.tera.setTexture('teraThink');
      this.tera.anims.play('teraThinkOut');
      this.tera.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkOut',
        () => {
          this.tera.setTexture('teraCorrect');
          this.tera.anims.play('teraCorrect');
        },
        this,
      );
    }
    if (
      (this.tera.anims.isPlaying && this.tera.anims.currentAnim.key == 'teraIdle') ||
      (this.tera.anims.isPlaying && this.tera.anims.currentAnim.key == 'teraWrong')
    ) {
      this.tera.setTexture('teraCorrect');
      this.tera.anims.play('teraCorrect');
    }

    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraCorrect',
      () => {
        this.tera.setTexture('teraIdle');
        this.tera.anims.play('teraIdle');
        this.objectFadeInOut(0, 1000, 500);
      },
      this,
    );
  }

  runWrongUi(wrongAttempt) {
    this.tera.setTexture('teraWrong');
    this.tera.anims.play('teraWrong');
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraWrong',
      () => {
        if (wrongAttempt <= 2) {
          this.tera.setTexture('teraThinkStart');
          this.tera.anims.play('teraThinkStart');
        }
        if (wrongAttempt > 2) {
          this.tera.setTexture('teraIdle');
          this.tera.anims.play('teraIdle');
        }
      },
      this,
    );
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkStart',
      () => {
        this.tera.setTexture('teraThinkLoop');
        this.tera.anims.play('teraThinkLoop');
      },
      this,
    );
  }

  runHintUiAnims() {
    this.tera.setTexture('teraIdea');
    this.tera.anims.play('teraIdea');
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraIdea',
      () => {
        this.tera.setTexture('teraIdle');
        this.tera.anims.play('teraIdle');
      },
      this,
    );
  }

  resetUi() {
    sound = true;
    settings = false;
    interacted = false;
    call = 0;
    animsList = [];
    value = 0;
    round = 0;
    circX = 530;
    bar = [];
  }

  teraRemove() {
    this.tera.setTexture('teraOut');
    this.tera.anims.play('teraOut');
  }

  removeProgressBar() {}
}
